export const PAYMENT_FAILURE_CONSTANTS = {
    TITLE: "Transaction failed",
    DESCRIPTION: "Any amount deducted will be refunded back to your account within 2-4 days.",
    BUTTON_TEXT: "Try other Payment Methods",
    PAYMENT_OF: "PAYMENT OF",
    IMAGE_ALT: "Payment Failure",
    ICON_WIDTH: 32,
    ICON_HEIGHT: 32,
};

export const IMAGES = {
    PAYMENT_FAILURE: "portal/static-assets/icons/digital-menu/payment/icon-error.png",
};
